/**
 * Detects null, empty or all-spaces
 *
 * @param str string to check
 * @returns true if the string is empty or blank spaces
 */
export const isEmptyOrSpaces = (str: string): boolean => {
  return str === null || str.match(/^ *$/) !== null;
};
